import axios from "./api-axios";

export async function httpGet(url, token, config) {
    const configAuth = {
        headers: {
            authorization: token ? `Bearer ${token}` : '',
        }
    }
    const configObject = config ? {...configAuth, ...config} : configAuth;
    try {
        const response = await axios.get(url, configObject);
        return response;
    } catch(error) {
        return error;
    }
}

export async function httpPost(url, token, data, config) {
    const configAuth = {
        headers: {
            authorization: token ? `Bearer ${token}` : '',
        }
    }
    const configObject = config ? {...configAuth, ...config} : configAuth;
    try {
        const response = await axios.post(url, data, configObject)
        return response;
    } catch(error) {
        return error;
    }
}

export async function httpPut(url, token, data, config) {
    const configAuth = {
        headers: {
            authorization: token ? `Bearer ${token}` : '',
        }
    }
    const configObject = config ? {...configAuth, ...config} : configAuth;
    try {
        const response = await axios.put(url, data, configObject);
        return response;
    } catch(error) {
        return error;
    }
}

export async function httpDelete(url, token, data, config) {
    const configAuth = {
        headers: {
            authorization: token ? `Bearer ${token}` : '',
        }
    }
    const configObject = config ? {...configAuth, ...config} : configAuth;
    try {
        const response = await axios.delete(url, {
            ...configObject,
            data
        });
        return response;
    } catch(error) {
        return error;
    }
}

const API_URL = process.env.REACT_APP_API_ENDPOINT;

export function getAssetUrlByRelativePath(relativePath) {
    return `${API_URL}/Assets/${relativePath}`
}